import { render, staticRenderFns } from "./OpportunityPreviewCard.vue?vue&type=template&id=3878a65a&scoped=true&"
import script from "./OpportunityPreviewCard.vue?vue&type=script&lang=js&"
export * from "./OpportunityPreviewCard.vue?vue&type=script&lang=js&"
import style0 from "./OpportunityPreviewCard.vue?vue&type=style&index=0&id=3878a65a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3878a65a",
  null
  
)

export default component.exports